import type { QueryObserverOptions } from "@tanstack/react-query";

import type { AssetApiClient } from "@skilitics/asset-register-api-client";
import { getIsAuthenticated } from "@skilitics/designer-auth/state";

import { getAssetBlob } from "../internal-shared/getAssetBlob.ts";
import { getAssetUrlQueryKey } from "./assetQueryKeys.ts";

// Store the Blob in the query cache so it can be GCed naturally.
export interface AssetQueryCacheData {
  assetId: string;
  blob: Blob | null;
}

// Factor out query so query cache has consistent entries (the AssetQueryCacheData above)
export const assetQuery = (
  api: AssetApiClient,
  assetId: string | null | undefined,
): QueryObserverOptions<AssetQueryCacheData | null> => ({
  enabled: !!assetId && getIsAuthenticated(),
  queryKey: getAssetUrlQueryKey(assetId),
  async queryFn({ signal }) {
    if (!assetId) return null;
    // Do we want to negatively cache that assetId wasn't founD?
    // Not sure what that looks like: maybe throw here and handle in onError.
    const blob = await getAssetBlob(api, assetId, signal);
    return { assetId, blob };
  },
});
